<template>
  <transition name="slide-fade">
    <div :class="{ 'alert-container': inline === false }" v-if="showAlert">
      <div
        :class="['alert', `alert-${variant}`, { 'alert-dismissible': isDismissible, fade: fade, show: showAlert }]"
        role="alert"
      >
        <div class="row align-items-center">
          <div v-if="icon" class="col-auto d-none d-sm-block">
            <font-awesome-icon :class="`text-${variant}`" class="icon" aria-hidden="true" :icon="icon" />
          </div>
          <div :class="[icon ? 'col-12 col-sm-10' : 'col-12']">
            <h2 class="h5 mt-1" v-if="heading">
              {{ heading }}
            </h2>
            <span v-if="message.msgHasLink">
              {{ message.msg1 }}
              <router-link :to="message.msgLink" class="alert-link" data-test="profileLink">
                {{ message.msgLinkText }}
              </router-link>
              {{ message.msg2 }}
            </span>
            <span v-else>{{ message.msg1 }}</span>
          </div>
          <button v-if="isDismissible" type="button" class="btn-close" aria-label="Close" @click="dismissAlert" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Alert',
  data() {
    return {
      style: {
        timer: null,
      },
    };
  },
  props: {
    dismissSecs: {
      type: Number,
      required: false,
    },
    isDismissible: {
      type: Boolean,
      default: true,
    },
    message: {
      type: Object,
      default() {
        return {
          msgHasLink: false,
          msg1: '',
          msg2: '',
          msgLinkText: '',
          msgLink: '',
        };
      },
    },
    heading: {
      type: String,
      required: false,
    },
    icon: {
      type: Array,
      required: false,
    },
    variant: {
      type: String,
      default: 'info',
    },
    showAlert: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    fade: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    message() {
      if (this.dismissSecs && this.showAlert) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (this.showAlert) {
            this.dismissAlert();
          }
        }, this.dismissSecs * 1000);
      }
    },
  },
  methods: {
    dismissAlert() {
      clearTimeout(this.timer);
      this.$emit('dismissAlert');
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';
.alert-container {
  position: fixed;
  z-index: 999;
  top: 30px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  .alert {
    width: 600px;
    max-width: 100%;
    margin: 0 auto;
  }
}
.slide-fade-enter-active {
  transition: all 0.3s ease-in;
}
.slide-fade-leave-active {
  transition: all 0.5s ease-out;
}
.slide-fade-enter {
  opacity: 0;
}
.slide-fade-leave-to {
  opacity: 0;
}
.icon {
  font-size: 22px;
}
.alert::v-deep .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1rem;
  color: $dark-grey;
  background: none;
  border: 0;
  border-radius: 0.375rem;
  opacity: 0.5;
  font-size: 25px;
  line-height: 25px;
}
</style>
